<template>
  <div>
    <b-card-actions
      ref="cardItem"
      action-refresh
      action-collapse
      no-body
      :title="`${item.disciplina} ${item.categoria}`"
      @refresh="updateConfig"
    >
      <!-- {{ item }} -->
      <b-row class="ml-1 mb-2">
        <b-col md="1">
          <span
            v-if="item.agrupar != 0 && item.agrupar != null"
            :style="
              `background-color:${
                colors[item.agrupar]
              }; padding:9px; border-radius:3px`
            "
            >A {{ item.agrupar }}</span
          >
        </b-col>
        <b-col md="1">
          <span
            v-if="item.agrupacion_pase != null"
            :style="
              `background-color:${
                colorPase[item.agrupacion_pase]
              }; padding:9px; border-radius:3px`
            "
            >P {{ item.agrupacion_pase }}</span
          >
        </b-col>
        <b-col md="10" style="text-align:right; right:10px">
          <span
            :class="
              item.dataCampeonato.activo === 's'
                ? 'camp-activo'
                : 'camp-anterior'
            "
            >Campeonato Activo: #{{ item.dataCampeonato.stringCampeonato }}
          </span>
        </b-col>
      </b-row>
      <b-row class="m-0">
        <b-col md="2" class="px-1" style="flex: 0 0 20%; max-width: 20%;">
          <b-card
            style="box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1) !important"
          >
            <h6 style="text-align:center">Inscripcion</h6>
            <b-form-group label="# Inscritos" label-for="numInscritos">
              <b-form-input
                v-model="item.total_jug_ins"
                id="numInscritos"
                type="number"
                size="sm"
                :disabled="
                  USER().rol === ROLES.SUPER ||
                  USER().rol === ROLES.ADMIN ||
                  USER().rol === ROLES.CALIFICACION
                    ? false
                    : true
                "
              />
            </b-form-group>

            <b-form-group
              label="Inicio Inscripcion"
              label-for="inicioInscripcion"
            >
              <b-form-input
                v-model="item.ini_inscripcion"
                id="inicioInscripcion"
                type="date"
                @input="verifyIsOpenInscription"
                size="sm"
                :disabled="
                  USER().rol === ROLES.SUPER ||
                  USER().rol === ROLES.ADMIN ||
                  USER().rol === ROLES.CALIFICACION
                    ? false
                    : true
                "
              />
            </b-form-group>
            <b-form-group label="Fin Inscripcion" label-for="finInscripcion">
              <b-form-input
                v-model="item.fin_inscripcion"
                id="finInscripcion"
                type="date"
                @input="verifyIsOpenInscription"
                size="sm"
                :disabled="
                  USER().rol === ROLES.SUPER ||
                  USER().rol === ROLES.ADMIN ||
                  USER().rol === ROLES.CALIFICACION
                    ? false
                    : true
                "
              />
            </b-form-group>
            <b-alert v-if="isOpen" class="mt-1" variant="success" show>
              <div class="alert-body">
                <span
                  ><strong>PERIODO DE INSCRIPCIONES ABIERTO!</strong> Finaliza
                  <span v-if="timeDiffInscription == 0">Hoy</span>
                  <span v-else>en {{ timeDiffInscription }} días</span>
                </span>
              </div>
            </b-alert>
            <b-alert v-else class="mt-1" variant="danger" show>
              <div class="alert-body">
                <span><strong>PERIODO DE INSCRIPCIONES CERRADO!</strong> </span>
              </div>
            </b-alert>
            <b-form-checkbox
              v-model="checkFacialWeb"
              :disabled="USER().rol === ROLES.SUPER ? false : true"
            >
              <p style="font-size:10px;color:gray !important">
                Activar Facial.Id
              </p>
            </b-form-checkbox>
          </b-card>
        </b-col>
        <b-col md="2" class="px-1" style="flex: 0 0 20%; max-width: 20%;">
          <b-card
            style="box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1) !important"
          >
            <h6 style="text-align:center">Validaciones</h6>
            <b-form-checkbox
              v-model="checkSub"
              :disabled="
                USER().rol === ROLES.SUPER ||
                USER().rol === ROLES.ADMIN ||
                USER().rol === ROLES.CALIFICACION
                  ? false
                  : true
              "
            >
              <p style="font-size:10px;color:gray !important">
                Validar por SUB
              </p>
            </b-form-checkbox>
            <b-form-group
              v-if="checkSub"
              label="Nacidos desde"
              label-for="nacidosDesde"
            >
              <b-form-input
                v-model="item.fecha_limite_permitido_desde"
                id="nacidosDesde"
                type="date"
                size="sm"
                :disabled="
                  USER().rol === ROLES.SUPER ||
                  USER().rol === ROLES.ADMIN ||
                  USER().rol === ROLES.CALIFICACION
                    ? false
                    : true
                "
              />
            </b-form-group>
            <b-form-group label="Nacidos hasta" label-for="nacidosHasta">
              <b-form-input
                v-model="item.fecha_limite_permitido"
                id="nacidosHasta"
                type="date"
                @input="calculateAgeLimitMax"
                size="sm"
                :disabled="
                  USER().rol === ROLES.SUPER ||
                  USER().rol === ROLES.ADMIN ||
                  USER().rol === ROLES.CALIFICACION
                    ? false
                    : true
                "
              />
            </b-form-group>
            <span
              v-if="!checkSub"
              style="font-size:11px; color:brown"
              :disabled="
                USER().rol === ROLES.SUPER ||
                USER().rol === ROLES.ADMIN ||
                USER().rol === ROLES.CALIFICACION
                  ? false
                  : true
              "
              >Se permite la inscripción de jugadores mayores a
              {{ limiteEdadMinima }} años
            </span>
            <span v-else style="font-size:11px; color:brown"
              >Se permite la inscripción de jugadores entre
              {{ limiteEdadMinima }} y {{ limiteEdadMaxima }} años
            </span>
            <b-form-checkbox
              class="mt-1"
              v-model="checkJuvenil"
              :disabled="
                USER().rol === ROLES.SUPER ||
                USER().rol === ROLES.ADMIN ||
                USER().rol === ROLES.CALIFICACION
                  ? false
                  : true
              "
            >
              <p style="font-size:10px;color:gray !important">
                Tiene Juvenil
              </p>
            </b-form-checkbox>
            <template v-if="checkJuvenil">
              <b-form-group
                v-show="checkJuvenilFechas"
                label="Juvenil Nacidos desde"
                label-for="minJuvenil"
              >
                <b-form-input
                  v-model="item.fecha_min_juvenil"
                  id="minJuvenil"
                  type="date"
                  size="sm"
                  :disabled="
                    USER().rol === ROLES.SUPER ||
                    USER().rol === ROLES.ADMIN ||
                    USER().rol === ROLES.CALIFICACION
                      ? false
                      : true
                  "
                />
              </b-form-group>
              <b-form-group
                v-show="!checkJuvenilFechas"
                label="Juvenil desde (años)"
                label-for="minJuvenilAnios"
              >
                <b-form-input
                  v-model="item.rango_juvenil.split(',')[0]"
                  id="minJuvenilAnios"
                  type="number"
                  size="sm"
                />
              </b-form-group>
              <b-form-group
                v-show="checkJuvenilFechas"
                label="Juvenil Nacidos hasta"
                label-for="minJuvenil"
              >
                <b-form-input
                  v-model="item.fecha_max_juvenil"
                  id="minJuvenil"
                  type="date"
                  size="sm"
                  :disabled="
                    USER().rol === ROLES.SUPER ||
                    USER().rol === ROLES.ADMIN ||
                    USER().rol === ROLES.CALIFICACION
                      ? false
                      : true
                  "
                />
              </b-form-group>
              <b-form-group
                v-if="item.tiene_juvenil_dos !== '0'"
                v-show="checkJuvenilFechas"
                label="Juvenil 2 hasta"
                label-for="minJuvenil"
              >
                <b-form-input
                  v-model="item.fecha_limite_hasta_juvenil_dos"
                  id="minJuvenil"
                  type="date"
                  size="sm"
                  :disabled="
                    USER().rol === ROLES.SUPER ||
                    USER().rol === ROLES.ADMIN ||
                    USER().rol === ROLES.CALIFICACION
                      ? false
                      : true
                  "
                />
              </b-form-group>
              <b-form-group
                v-show="!checkJuvenilFechas"
                label="Juvenil hasta (años)"
                label-for="maxJuvenilAnios"
              >
                <b-form-input
                  v-model="item.rango_juvenil.split(',')[2]"
                  id="maxJuvenilAnios"
                  type="number"
                  size="sm"
                  :disabled="
                    USER().rol === ROLES.SUPER ||
                    USER().rol === ROLES.ADMIN ||
                    USER().rol === ROLES.CALIFICACION
                      ? false
                      : true
                  "
                />
              </b-form-group>
            </template>
            <template v-if="checkJuvenil">
              <span
                v-if="checkJuvenilFechas"
                style="font-size:11px; color:brown;"
                >Son JUVENILES los jugadores entre
                {{ limiteEdadMinimaJuvenil }} y {{ limiteEdadMaxJuvenil }} años
                <span v-if="item.tiene_juvenil_dos !== '0'">o mayores a {{ limiteEdadMinimaJuvenilDos }} años</span>
              </span>
              <span v-else style="font-size:11px; color:brown;"
                >Son JUVENILES los jugadores entre
                {{ item.rango_juvenil.split(',')[0] }} y
                {{ item.rango_juvenil.split(',')[2] }} años
              </span>
            </template>
            <b-form-checkbox
              class="mt-1"
              v-model="checkClasificado"
              :disabled="
                USER().rol === ROLES.SUPER ||
                USER().rol === ROLES.ADMIN ||
                USER().rol === ROLES.CALIFICACION
                  ? false
                  : true
              "
            >
              <p style="font-size:10px;color:gray !important">
                Tiene Clasificado
              </p>
            </b-form-checkbox>
            <div>
              <span style="font-size:12px; font-weight:bold"
                >Tipo Jugador extra</span
              >
              <b-button
                v-if="
                  USER().rol === ROLES.SUPER ||
                    USER().rol === ROLES.ADMIN ||
                    USER().rol === ROLES.CALIFICACION
                "
                v-b-tooltip.hover.v-primary
                title="Agregar Tipo"
                variant="flat-primary"
                class="btn-icon"
                @click="showNewTipoAlterno"
              >
                <feather-icon size="22" icon="PlusSquareIcon" />
              </b-button>
              <b-row
                class="mt-1"
                v-for="tipo in item.tipos_en_categoria"
                :key="tipo.id_categoria_tipos_alternos"
                style="align-items:center; border-bottom:1px solid #e5dfdf"
              >
                <b-col md="9">
                  <div style="font-size:11px;color:gray">
                    {{ tipo.tipo_alterno }}
                  </div>
                </b-col>
                <b-col md="3">
                  <feather-icon
                    v-if="
                      USER().rol === ROLES.SUPER ||
                        USER().rol === ROLES.ADMIN ||
                        USER().rol === ROLES.TESORERIA
                    "
                    icon="Trash2Icon"
                    size="16"
                    style="cursor:pointer"
                    @click="deleteTipoAlterno(tipo)"
                  />
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
        <b-col md="2" class="px-1" style="flex: 0 0 20%; max-width: 20%;">
          <b-card
            style="box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1) !important"
          >
            <h6 style="text-align:center">Tarjetas y Valores</h6>
            <b-form-checkbox
              v-model="checkBorranConRoja"
              :disabled="
                USER().rol === ROLES.SUPER ||
                USER().rol === ROLES.ADMIN ||
                USER().rol === ROLES.TECNICA
                  ? false
                  : true
              "
            >
              <span style="font-size:10px;color:gray !important">
                Amarillas borran con roja
              </span>
            </b-form-checkbox>
            <b-form-group label="Amarillas para suspensión" label-for="numAA">
              <b-form-input
                v-model="item.num_am_to_susp"
                id="numAA"
                type="number"
                size="sm"
                :disabled="
                  USER().rol === ROLES.SUPER ||
                  USER().rol === ROLES.ADMIN ||
                  USER().rol === ROLES.TECNICA
                    ? false
                    : true
                "
              />
            </b-form-group>
            <div style="text-align:center">
              <b-button
                v-if="
                  USER().rol === ROLES.SUPER ||
                    USER().rol === ROLES.ADMIN ||
                    USER().rol === ROLES.TESORERIA
                "
                v-b-tooltip.hover.v-primary
                title="Resetear T.A a 0, rojo existe config, gris valores por defecto"
                :variant="item.tiene_reset_amarillas ? 'danger' : 'secondary'"
                class="btn-icon mb-1"
                size="sm"
                @click="showResetTa"
              >
                Resetear Tarjetas
              </b-button>
            </div>
            <b-form-group label="$ T.A" label-for="valAmarilla">
              <b-form-input
                v-model="item.valor_amarilla"
                id="valAmarilla"
                type="number"
                size="sm"
                :disabled="
                  USER().rol === ROLES.SUPER ||
                  USER().rol === ROLES.ADMIN ||
                  USER().rol === ROLES.TECNICA ||
                  USER().rol === ROLES.TESORERIA
                    ? false
                    : true
                "
              />
            </b-form-group>
            <b-form-group
              label="Goles por no presentación"
              label-for="numTitulares"
            >
              <b-form-input
                v-model="item.goles_no_presentacion"
                id="numTitulares"
                type="number"
                size="sm"
                :disabled="
                  USER().rol === ROLES.SUPER ||
                  USER().rol === ROLES.ADMIN ||
                  USER().rol === ROLES.TECNICA
                    ? false
                    : true
                "
              />
            </b-form-group>
            <div
              style="background:#f8f9fb; border:1px solid #edf1f5; border-radius:8px; padding:8px; margin-top:8px;"
            >
              <div
                style="display:flex; align-items:center; justify-content:space-between; margin-bottom:6px;"
              >
                <span style="font-size:12px; font-weight:600"
                  >Valores Fijos</span
                >
                <b-button
                  v-if="
                    USER().rol === ROLES.SUPER ||
                      USER().rol === ROLES.ADMIN ||
                      USER().rol === ROLES.TESORERIA
                  "
                  v-b-tooltip.hover.v-primary
                  title="Crear Valor fijo"
                  variant="flat-primary"
                  class="btn-icon"
                  @click="showNewValorFijo"
                >
                  <feather-icon size="22" icon="PlusSquareIcon" />
                </b-button>
              </div>
              <b-row
                v-for="valor_fijo in item.valores_fijos"
                :key="valor_fijo.id_valor_fijo"
                style="align-items:center; margin-bottom:4px;"
              >
                <b-col md="7">
                  <b-form-group
                    :label="valor_fijo.descripcion"
                    :label-for="valor_fijo.descripcion"
                  >
                    <b-form-input
                      v-model="valor_fijo.valor"
                      :id="valor_fijo.descripcion"
                      type="number"
                      size="sm"
                      :disabled="
                        USER().rol === ROLES.SUPER ||
                        USER().rol === ROLES.ADMIN ||
                        USER().rol === ROLES.TESORERIA
                          ? false
                          : true
                      "
                    />
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-checkbox
                    v-model="valor_fijo.is_activo_boolean"
                    :disabled="
                      USER().rol === ROLES.SUPER ||
                      USER().rol === ROLES.ADMIN ||
                      USER().rol === ROLES.TESORERIA
                        ? false
                        : true
                    "
                  >
                  </b-form-checkbox>
                </b-col>
                <b-col md="1">
                  <feather-icon
                    v-if="
                      USER().rol === ROLES.SUPER ||
                        USER().rol === ROLES.ADMIN ||
                        USER().rol === ROLES.TESORERIA
                    "
                    icon="Trash2Icon"
                    size="16"
                    style="cursor:pointer"
                    @click="deleteValorFijo(valor_fijo)"
                  />
                </b-col>
              </b-row>
              <div
                style="font-size:10px; background: #ef924d; color: white; padding: 3px;border-radius: 3px; margin-top:6px;"
              >
                Importante: los valores fijos activados serán agregados al
                recibo automáticamente
              </div>
            </div>
            <!-- <b-form-group label="$ Arb." label-for="arbitraje">
              <b-form-input
                v-model="item.arbitraje"
                id="arbitraje"
                type="number"
                size="sm"
                :disabled="
                  USER().rol === ROLES.SUPER ||
                  USER().rol === ROLES.ADMIN ||
                  USER().rol === ROLES.TESORERIA ||
                  USER().rol === ROLES.TECNICA
                    ? false
                    : true
                "
              />
            </b-form-group>
            <b-form-group label="$ Voc" label-for="del_vocal">
              <b-form-input
                v-model="item.del_vocal"
                id="del_vocal"
                type="number"
                size="sm"
                :disabled="
                  USER().rol === ROLES.SUPER ||
                  USER().rol === ROLES.ADMIN ||
                  USER().rol === ROLES.TESORERIA ||
                  USER().rol === ROLES.TECNICA
                    ? false
                    : true
                "
              />
            </b-form-group>
            <b-form-group label="$ Otros" label-for="del_vocal">
              <b-form-input
                v-model="item.valor_adicional"
                id="adicional"
                type="number"
                size="sm"
                :disabled="
                  USER().rol === ROLES.SUPER ||
                  USER().rol === ROLES.ADMIN ||
                  USER().rol === ROLES.TESORERIA ||
                  USER().rol === ROLES.TECNICA
                    ? false
                    : true
                "
              />
            </b-form-group> -->
            <!-- <b-form-checkbox
              v-model="checkRestarGoles"
              :disabled="
                USER().rol === ROLES.SUPER ||
                USER().rol === ROLES.ADMIN ||
                USER().rol === ROLES.TECNICA
                  ? false
                  : true
              "
            >
              <p style="font-size:10px;color:gray !important">
                Restar goles cuando los dos no se presentan
              </p>
            </b-form-checkbox> -->
          </b-card>
        </b-col>
        <b-col md="2" class="px-1" style="flex: 0 0 20%; max-width: 20%;">
          <b-card
            style="box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1) !important"
          >
            <h6 style="text-align:center">Vocalia</h6>
            <b-form-group label="# Titulares" label-for="numTitulares">
              <b-form-input
                v-model="item.num_titulares"
                id="numTitulares"
                type="number"
                size="sm"
                :disabled="
                  USER().rol === ROLES.SUPER ||
                  USER().rol === ROLES.ADMIN ||
                  USER().rol === ROLES.TECNICA
                    ? false
                    : true
                "
              />
            </b-form-group>
            <b-form-group label="# Suplentes" label-for="numSuplentes">
              <b-form-input
                v-model="item.num_suplentes"
                id="numSuplentes"
                type="number"
                size="sm"
                :disabled="
                  USER().rol === ROLES.SUPER ||
                  USER().rol === ROLES.ADMIN ||
                  USER().rol === ROLES.TECNICA
                    ? false
                    : true
                "
              />
            </b-form-group>
            <b-form-group
              v-if="item.tiene_recambios !== '0'"
              label="# Recambios"
              label-for="numRecambios"
            >
              <b-form-input
                v-model="item.num_recambios"
                id="numRecambios"
                type="number"
                size="sm"
                :disabled="
                  USER().rol === ROLES.SUPER ||
                  USER().rol === ROLES.ADMIN ||
                  USER().rol === ROLES.TECNICA
                    ? false
                    : true
                "
              />
            </b-form-group>
             <b-form-group
              label="Minutos de juego"
              label-for="numMinutos"
            >
              <b-form-input
                v-model="item.minutos_juego"
                id="numMinutos"
                type="number"
                size="sm"
                :disabled="
                  USER().rol === ROLES.SUPER ||
                  USER().rol === ROLES.ADMIN ||
                  USER().rol === ROLES.TECNICA
                    ? false
                    : true
                "
              />
            </b-form-group>
            <b-form-checkbox
              v-model="checkBalon"
              :disabled="
                USER().rol === ROLES.SUPER ||
                USER().rol === ROLES.ADMIN ||
                USER().rol === ROLES.TECNICA
                  ? false
                  : true
              "
            >
              <p style="font-size:10px;color:gray !important">
                Balon
              </p>
            </b-form-checkbox>
            <b-form-checkbox
              v-model="checkCapitan"
              :disabled="
                USER().rol === ROLES.SUPER ||
                USER().rol === ROLES.ADMIN ||
                USER().rol === ROLES.TECNICA
                  ? false
                  : true
              "
            >
              <p style="font-size:10px;color:gray !important">
                C.Capitan
              </p>
            </b-form-checkbox>
            <b-form-checkbox
              v-model="checkCamerino"
              :disabled="
                USER().rol === ROLES.SUPER ||
                USER().rol === ROLES.ADMIN ||
                USER().rol === ROLES.TECNICA
                  ? false
                  : true
              "
            >
              <p style="font-size:10px;color:gray !important">
                Camerino
              </p>
            </b-form-checkbox>
            <b-form-checkbox
              v-model="checkTribuna"
              :disabled="
                USER().rol === ROLES.SUPER ||
                USER().rol === ROLES.ADMIN ||
                USER().rol === ROLES.TECNICA
                  ? false
                  : true
              "
            >
              <p style="font-size:10px;color:gray !important">
                Tribuna
              </p>
            </b-form-checkbox>
            <b-form-checkbox
              v-model="checkFaltas"
              :disabled="
                USER().rol === ROLES.SUPER ||
                USER().rol === ROLES.ADMIN ||
                USER().rol === ROLES.TECNICA
                  ? false
                  : true
              "
            >
              <p style="font-size:10px;color:gray !important">
                Faltas
              </p>
            </b-form-checkbox>
            <b-form-checkbox
              v-model="checkCalificacion"
              :disabled="
                USER().rol === ROLES.SUPER ||
                USER().rol === ROLES.ADMIN ||
                USER().rol === ROLES.TECNICA
                  ? false
                  : true
              "
            >
              <p style="font-size:10px;color:gray !important">
                C.Arbitral
              </p>
            </b-form-checkbox>
            <template v-if="checkCalificacion">
              <b-form-radio-group
                :options="item.opciones_calificacion"
                v-model="radioSelect"
                value-field="id_opc_cal_arbitro"
                text-field="descripcion"
                class="radio-opciones"
                :disabled="
                  USER().rol === ROLES.SUPER ||
                  USER().rol === ROLES.ADMIN ||
                  USER().rol === ROLES.TECNICA
                    ? false
                    : true
                "
              >
              </b-form-radio-group>
            </template>
            <b-form-checkbox
              v-model="checkUsanCodigos"
              :disabled="
                USER().rol === ROLES.SUPER ||
                USER().rol === ROLES.ADMIN ||
                USER().rol === ROLES.TECNICA
                  ? false
                  : true
              "
            >
              <p style="font-size:10px;color:gray !important">
                Usan codigos camisetas
              </p>
            </b-form-checkbox>
            <b-form-checkbox
              v-model="checkBloquearInformeArbitroWeb"
              :disabled="USER().rol === ROLES.SUPER ? false : true"
            >
              <p style="font-size:10px;color:gray !important">
                Bloquear Inf.arbitral al guardar
              </p>
            </b-form-checkbox>
            <b-form-checkbox
              v-model="checkFacialVocalia"
              :disabled="USER().rol === ROLES.SUPER ? false : true"
            >
              <p style="font-size:10px;color:gray !important">
                Activar R.Facial
              </p>
            </b-form-checkbox>
          </b-card>
        </b-col>
        <b-col md="2" class="px-1" style="flex: 0 0 20%; max-width: 20%;">
          <b-card
            style="box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1) !important"
          >
            <h6 style="text-align:center">App Movil</h6>
            <b-form-checkbox
              v-model="checkMostrarMovil"
              :disabled="
                USER().rol === ROLES.SUPER ||
                USER().rol === ROLES.ADMIN ||
                USER().rol === ROLES.TECNICA
                  ? false
                  : true
              "
            >
              <p style="font-size:10px;color:gray !important">
                Mostrar Categoria
              </p>
            </b-form-checkbox>

            <b-form-checkbox
              v-model="checkPlayOffs"
              :disabled="
                USER().rol === ROLES.SUPER ||
                USER().rol === ROLES.ADMIN ||
                USER().rol === ROLES.TECNICA
                  ? false
                  : true
              "
            >
              <p style="font-size:10px;color:gray !important">
                Mostrar PlayOffs
              </p>
            </b-form-checkbox>
            <div class="d-flex">
              <b-form-checkbox
                v-model="checkAcumulada"
                :disabled="
                  USER().rol === ROLES.SUPER ||
                  USER().rol === ROLES.ADMIN ||
                  USER().rol === ROLES.TECNICA
                    ? false
                    : true
                "
              >
                <p style="font-size:10px;color:gray !important">
                  Mostrar Acumulada
                </p>
              </b-form-checkbox>
              <b-button
                v-b-tooltip.hover.v-primary
                title="Configuración"
                variant="outline-primary"
                class="btn-icon ml-1"
                size="sm"
                @click="showNewConfigAcumulada()"
              >
                <feather-icon size="17" icon="SettingsIcon" />
              </b-button>
            </div>
            <b-form-checkbox
              v-model="checkVocaliasWeb"
              :disabled="USER().rol === ROLES.SUPER ? false : true"
            >
              <p style="font-size:10px;color:gray !important">
                Mostrar vocalias
              </p>
            </b-form-checkbox>
            <b-form-checkbox
              v-model="checkEdadWeb"
              :disabled="USER().rol === ROLES.SUPER ? false : true"
            >
              <p style="font-size:10px;color:gray !important">
                Mostrar edad
              </p>
            </b-form-checkbox>
            <div
              style="font-weight: bold; font-size: 1rem; text-align: center;"
            >
              Modalidad Campeonato
            </div>
            <b-button
              v-if="
                USER().rol === ROLES.SUPER ||
                  USER().rol === ROLES.ADMIN ||
                  USER().rol === ROLES.TECNICA
              "
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="primary"
              class="mt-1"
              size="sm"
              @click="getModalidad(item.id_categoria)"
            >
              Crear Modalidad
            </b-button>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col md="12" class="text-center">
          <b-button
            v-if="USER().rol === ROLES.SUPER"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="danger"
            @click="eliminar(item)"
          >
            Eliminar
          </b-button>
        </b-col>
      </b-row>
    </b-card-actions>
  </div>
</template>

<script>
/* eslint-disable */
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
// import modalEtapas from './ModalEtapas.vue'
import store from '@/store'

// import { onMounted, ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'

import {
  BFormCheckbox,
  BAlert,
  BButton,
  //   VBTooltip,
  BRow,
  BCol,
  BFormInput,
  BFormGroup,
  BFormRadio,
  BFormRadioGroup,
  //   BTable,
  //   BMedia,
  //   BAvatar,
  VBTooltip,
  BCard,
  //   BBadge,
} from 'bootstrap-vue'
import { watch, ref, computed } from '@vue/composition-api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import apiCall from '../../utils/apiCall'
import { URL, USER, ROLES } from '../../utils/variables'
import AddValorFijo from './AddValorFijo.vue'

const moment = require('moment-timezone')

moment.tz.setDefault('America/Guayaquil')

export default {
  components: {
    // BCard,
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BFormCheckbox,
    BCardActions,
    BAlert,
    VBTooltip,
    BButton,
    BCard,
    BFormRadio,
    BFormRadioGroup,
    AddValorFijo,
    // modalEtapas,
  },
  props: {
    item: Object,
    opcionesCal: Array,
    listAux: Array,
    index: Number,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  setup(props, { emit }) {
    const { postApi, getApi } = apiCall()
    const radioSelect = ref(props.item.id_opc_cal_arbitro)
    // eslint-disable-next-line
    const checkSub = ref(props.item.controla_por_sub === 's' ? true : false)
    // eslint-disable-next-line
    const checkJuvenil = ref(props.item.tiene_juvenil === 's' ? true : false)
    const checkClasificado = ref(
      props.item.tiene_clasificado === 's' ? true : false,
    )
    const checkBorranConRoja = ref(
      props.item.borran_con_roja === 's' ? true : false,
    )
    const checkRestarGoles = ref(
      props.item.restar_gol_np === 's' ? true : false,
    )
    const itemAux = { ...props.item }
    const checkPlayOffs = ref(props.item.playofs === 's' ? true : false)
    const checkBalon = ref(props.item.balon === 's' ? true : false)
    const checkCapitan = ref(props.item.c_capitan === 's' ? true : false)
    const checkTribuna = ref(props.item.tribuna === 's' ? true : false)
    const checkCamerino = ref(props.item.camerino === 's' ? true : false)
    const checkFaltas = ref(props.item.faltas === 's' ? true : false)
    const checkPasabolas = ref(props.item.pasabolas === 's' ? true : false)
    const checkAcumulada = ref(props.item.show_acumulada === '1' ? true : false)
    const checkMostrarMovil = ref(
      props.item.mostrar_movil === 's' ? true : false,
    )
    const checkUsanCodigos = ref(
      props.item.usan_numeros_diferentes === '1' ? true : false,
    )

    const checkFacialWeb = ref(
      props.item.show_facial_web === '1' ? true : false,
    )
    const checkFacialVocalia = ref(
      props.item.show_facial_vocalia === '1' ? true : false,
    )
    const checkCalificacion = ref(
      props.item.calificacion_arbitro === 's' ? true : false,
    )
    const checkVocaliasWeb = ref(props.item.show_vocalia === '1' ? true : false)
    const checkEdadWeb = ref(props.item.show_edad === '1' ? true : false)
    const checkBloquearInformeArbitroWeb = ref(
      props.item.bloquear_informe_arbitro === '1' ? true : false,
    )
    async function deleteValorFijo(item) {
      // const data = {
      //   articulo: props.valorFijo.motivo,
      //   valor: props.valorFijo.valor,
      //   detalle: props.valorFijo.detalle,
      // }
      const path = 'ApiConfiguration/deleteValorFijo'
      const response = await postApi(URL, path, item)
      // console.log(response)
      if (response.flag === 'si') {
        emit('deleteFijo', item)
      }
    }
    async function deleteTipoAlterno(item) {
      // const data = {
      //   articulo: props.valorFijo.motivo,
      //   valor: props.valorFijo.valor,
      //   detalle: props.valorFijo.detalle,
      // }
      const path = 'ApiConfiguration/deleteTipoAlterno'
      const response = await postApi(URL, path, item)
      // console.log(response)
      if (response.flag === 'si') {
        emit('deleteTipoAlterno', item)
      }
    }
    async function eliminar(item) {
      const path = 'ApiConfiguration/deleteCategoria'
      // console.log(item)
      const dataDelete = {
        idCategoria: item.id_categoria,
      }
      // console.log(dataDelete)
      if (dataDelete.idEquipo !== null) {
        const data = await postApi(URL, path, dataDelete)
        if (data === null) {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title:
                  'ERROR, existe multiple información asociada al elemento. Acción no permitida',
                icon: 'AlertCircleIcon',
                variant: 'danger',
                solid: true,
              },
            },
            {
              position: 'top-center',
              // eslint-disable-next-line
            },
          )
        } else if (data !== null) {
          // showConfirmacionEliminar.value = false
          if (data.flag === 'si') {
            // const found = props.listInstituciones.findIndex(
            //   // eslint-disable-next-line
            //   element => element.id_institucion === dataDelete.idInstitucion
            // )
            // props.listInstituciones.splice(found, 1)

            // emit('limpiaDerecha', true)
            emit('recargarCategorias')

            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: 'CATEGORIA eliminada exitosamente',
                  icon: 'CheckIcon',
                  variant: 'success',
                  solid: true,
                },
              },
              {
                position: 'top-center',
                // eslint-disable-next-line
              },
            )
          } else {
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: 'ERROR no se pudo eliminar',
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                  solid: true,
                },
              },
              {
                position: 'top-center',
                // eslint-disable-next-line
              },
            )
          }
        }
      } else {
        listCategoriasUsadasNoUsadas.value.splice(item.pos, 1)
        listCategoriasUsadasNoUsadas.value.forEach((element, index) => {
          element.pos = index
        })
      }
    }
    // const checkJuvenilFechas = ref(
    //   // eslint-disable-next-line
    //   props.item.validar_por_anios === 's' ? true : false
    // )
    const checkJuvenilFechas = ref(true)
    const cardItem = ref()
    const listEtapas = ref([])
    const colors = ref([
      'white',
      'yellow',
      'aqua',
      'chartreuse',
      '#ffbebe',
      'lightblue',
      '#e5c9ff',
      '#ade6ff',
      '#c3c8ca',
      '#ffc1ee',
      '#ffdf08',
      '#84b4ff',
      '#2ed8b7',
      '#ffb900',
      '#00d4ff',
      '#c7cb85',
      '#f19c67',
      '#cfb09e',
    ])
    const colorPase = ref([
      'white',
      '#cfb09e',
      'yellow',
      'aqua',
      'chartreuse',
      '#ffbebe',
      'lightblue',
      '#e5c9ff',
      '#ade6ff',
      '#c3c8ca',
      '#ffc1ee',
      '#ffdf08',
      '#84b4ff',
      '#2ed8b7',
      '#ffb900',
      '#00d4ff',
      '#c7cb85',
      '#f19c67',
    ])
    // const timeDiffInscription = ref('')
    // const limiteEdadMinima = ref(moment.duration(moment().diff(props.item.fecha_limite_permitido)).years())
    // watch(checkSub, (selection, prevSelection) => {
    //   console.log(selection, prevSelection)
    // })
    function calculateAgeLimitMax(date) {
      // const years = moment().diff(date, 'YYYY-MM-DD')
      const diffDuration = moment.duration(moment().diff(date))
      // limiteEdadMinima.value = diffDuration.years()
      return diffDuration.years()
      // console.log(limiteEdadMinima)
    }
    function calculaTiempoRestante(date) {
      const diffDuration = moment.duration(moment().diff(`${date} 23:59:59`))
      // console.log(diffDuration)
      // limiteEdadMinima.value = diffDuration.years()
      // timeDiffInscription.value = `${diffDuration.days()}`
      // console.log(diffDuration)
      if (diffDuration.months() == 0) {
        return diffDuration.days() * -1
      } else {
        return `${diffDuration.months() * -1} mes ${diffDuration.days() * -1}`
      }

      // console.log(limiteEdadMinima)
    }
    function verifyIsOpenInscription() {
      const hoy = moment().format('YYYY-MM-DD')
      const isOpen = moment(hoy).isBetween(
        props.item.ini_inscripcion,
        props.item.fin_inscripcion,
        undefined,
        // eslint-disable-next-line
        '[]',
      )
      // console.log(isOpen)
      return isOpen
    }
    const limiteEdadMaxima = computed(() =>
      calculateAgeLimitMax(props.item.fecha_limite_permitido_desde),
    )
    const limiteEdadMinima = computed(() =>
      calculateAgeLimitMax(props.item.fecha_limite_permitido),
    )
    const limiteEdadMaxJuvenil = computed(() =>
      calculateAgeLimitMax(props.item.fecha_min_juvenil),
    )
    const limiteEdadMinimaJuvenil = computed(() =>
      calculateAgeLimitMax(props.item.fecha_max_juvenil),
    )
    const limiteEdadMinimaJuvenilDos = computed(() =>
      calculateAgeLimitMax(props.item.fecha_limite_hasta_juvenil_dos),
    )
    const timeDiffInscription = computed(() =>
      calculaTiempoRestante(props.item.fin_inscripcion),
    )
    const isOpen = computed(() => verifyIsOpenInscription())
    function showResetTa(item) {
      emit('showResetTa', item)
    }
    function showNewValorFijo() {
      emit('newValorFijo')
    }
    function showNewConfigAcumulada() {
      emit('newConfigAcumulada')
    }
    function showNewTipoAlterno() {
      emit('newTipoAlterno')
    }

    async function getModalidad(idCategoria) {
      emit('getModalidad', idCategoria)
      // listEtapas.value = []
      // store.commit('someVariables/UPDATE_SHOW_MODAL_ETAPAS', true)
      // const path = `ApiConfiguration/getModalidad/${idCategoria}`
      // const response = await getApi(URL, path)
      // listEtapas.value = response
      // console.log(listEtapas.value)
    }
    function verifyChanges(item) {
      // console.log(item)
      let cambio = ''
      const itemCom = props.listAux[props.index]
      // console.log(itemCom)

      if (item.total_jug_ins != itemCom.total_jug_ins) {
        cambio += `Config Total de inscritos cambia de  ${itemCom.total_jug_ins} a ${item.total_jug_ins} jugadores; `
      }
      if (item.ini_inscripcion != itemCom.ini_inscripcion) {
        cambio += `Config Fecha Inicio de inscripción cambia de ${itemCom.ini_inscripcion} a ${item.ini_inscripcion}; `
      }
      if (item.fin_inscripcion != itemCom.fin_inscripcion) {
        cambio += `Config Fecha Fin de inscripción cambia de ${itemCom.fin_inscripcion} a ${item.fin_inscripcion}; `
      }
      if (item.controla_por_sub != itemCom.controla_por_sub) {
        cambio += `Config Nacidos rango fechas cambia de ${itemCom.controla_por_sub} a ${item.controla_por_sub}; `
      }
      if (item.fecha_limite_permitido != itemCom.fecha_limite_permitido) {
        cambio += `Config Fecha Nacidos hasta cambia de ${itemCom.fecha_limite_permitido} a ${item.fecha_limite_permitido}; `
      }
      if (
        item.fecha_limite_permitido_desde !=
        itemCom.fecha_limite_permitido_desde
      ) {
        cambio += `Config Fecha Nacidos desde cambia de ${itemCom.fecha_limite_permitido_desde} a ${item.fecha_limite_permitido_desde}; `
      }
      if (item.tiene_juvenil != itemCom.tiene_juvenil) {
        cambio += `Config Tiene juvenil cambia de ${itemCom.tiene_juvenil} a ${item.tiene_juvenil}; `
      }
      if (item.fecha_min_juvenil != itemCom.fecha_min_juvenil) {
        cambio += `Config Fecha minima juvenil cambia de ${itemCom.fecha_min_juvenil} a ${item.fecha_min_juvenil}; `
      }
      if (item.fecha_max_juvenil != itemCom.fecha_max_juvenil) {
        cambio += `Config Fecha maxima juvenil cambia de ${itemCom.fecha_max_juvenil} a ${item.fecha_max_juvenil}; `
      }
      if (
        item.fecha_limite_hasta_juvenil_dos !=
        itemCom.fecha_limite_hasta_juvenil_dos
      ) {
        cambio += `Config Fecha juvenil Adulto cambia de ${itemCom.fecha_limite_hasta_juvenil_dos} a ${item.fecha_limite_hasta_juvenil_dos}; `
      }
      if (item.tiene_clasificado != itemCom.tiene_clasificado) {
        cambio += `Config Jugador Clasificado cambia de ${itemCom.tiene_clasificado} a ${item.tiene_clasificado}; `
      }
      if (item.borran_con_roja != itemCom.borran_con_roja) {
        cambio += `Config Amarillas se borran con roja cambia de ${itemCom.borran_con_roja} a ${item.borran_con_roja}; `
      }
      if (item.num_am_to_susp != itemCom.num_am_to_susp) {
        cambio += `Config # Amarillas para suspensión cambia de ${itemCom.num_am_to_susp} a ${item.num_am_to_susp}; `
      }
      if (item.valor_amarilla != itemCom.valor_amarilla) {
        cambio += `Config valor T.Amarilla cambia de  $${itemCom.valor_amarilla} a $${item.valor_amarilla}; `
      }
      item.valores_fijos.forEach((element, index) => {
        if (element.valor !== itemCom.valores_fijos[index].valor) {
          cambio += `Config valor ${element.descripcion} cambia de  $${itemCom.valores_fijos[index].valor} a $${element.valor}; `
        }
        if (
          element.is_activo_boolean !==
          itemCom.valores_fijos[index].is_activo_boolean
        ) {
          cambio += `Config estado ${element.descripcion} cambia de  ${itemCom.valores_fijos[index].is_activo_boolean} a ${element.is_activo_boolean}; `
        }
      })
      // if (item.arbitraje != itemCom.arbitraje) {
      //   cambio += `Config valor arbitraje cambia de  $${itemCom.arbitraje} a $${item.arbitraje}; `
      // }
      // if (item.del_vocal != itemCom.del_vocal) {
      //   cambio += `Config valor arbitraje cambia de  $${itemCom.del_vocal} a $${item.del_vocal}; `
      // }
      // if (item.valor_adicional != itemCom.valor_adicional) {
      //   cambio += `Config valor otros cambia de  $${itemCom.valor_adicional} a $${item.valor_adicional}; `
      // }
      if (item.goles_no_presentacion != itemCom.goles_no_presentacion) {
        cambio += `Config goles no presentación cambia de  ${itemCom.goles_no_presentacion} a ${item.goles_no_presentacion}; `
      }
      if (item.num_titulares != itemCom.num_titulares) {
        cambio += `Config Num Titulares , cambia de  ${itemCom.num_titulares} a ${item.num_titulares}; `
      }
      if (item.num_suplentes != itemCom.num_suplentes) {
        cambio += `Config Num Suplentes cambia de  ${itemCom.num_suplentes} a ${item.num_suplentes}; `
      }
       if (item.num_recambios != itemCom.num_recambios) {
        cambio += `Config Num Recambios cambia de  ${itemCom.num_recambios} a ${item.num_recambios}; `
      }
      if (item.minutos_juego != itemCom.minutos_juego) {
        cambio += `Config Minutos de juego cambia de  ${itemCom.minutos_juego} a ${item.minutos_juego}; `
      }
      if (item.balon != itemCom.balon) {
        cambio += `Config Presenta Balón cambia de  ${itemCom.balon} a ${item.balon}; `
      }
      if (item.c_capitan != itemCom.c_capitan) {
        cambio += `Config Presenta C.Capitán cambia de  ${itemCom.c_capitan} a ${item.c_capitan}; `
      }
      if (item.camerino != itemCom.camerino) {
        cambio += `Config Camerino cambia de  ${itemCom.camerino} a ${item.camerino}; `
      }
      if (item.tribuna != itemCom.tribuna) {
        cambio += `Config Tribuna cambia de  ${itemCom.tribuna} a ${item.tribuna}; `
      }
      if (item.faltas != itemCom.faltas) {
        cambio += `Config Contador Faltas cambia de  ${itemCom.faltas} a ${item.faltas}; `
      }
      if (item.calificacion != itemCom.calificacion_arbitro) {
        cambio += `Config Calificación Arbitral cambia de  ${itemCom.calificacion_arbitro} a ${item.calificacion}; `
      }
      if (item.id_opc_cal_arbitro != itemCom.id_opc_cal_arbitro) {
        cambio += `Config Opcion Calificación Arbitral cambia de  ${itemCom.id_opc_cal_arbitro} a ${item.opc_cal_arbitro}; `
      }
      if (item.playofs != itemCom.playofs) {
        cambio += `Config mostrar playoffs cambia de  ${itemCom.playofs} a ${item.playofs}; `
      }
      if (item.show_acumulada != itemCom.show_acumulada) {
        cambio += `Config mostrar acumulada cambia de  ${itemCom.show_acumulada} a ${item.show_acumulada}; `
      }
      if (item.show_facial_web != itemCom.show_facial_web) {
        cambio += `Config R.Facial Web cambia de  ${itemCom.show_facial_web} a ${item.show_facial_web}; `
      }
      if (item.show_facial_vocalia != itemCom.show_facial_vocalia) {
        cambio += `Config R.Facial Vocalia cambia de  ${itemCom.show_facial_vocalia} a ${item.show_facial_vocalia}; `
      }
      if (item.mostrar_movil != itemCom.mostrar_movil) {
        cambio += `Config Mostrar Movil cambia de  ${itemCom.mostrar_movil} a ${item.mostrar_movil}; `
      }
      if (item.usan_numeros_diferentes != itemCom.usan_numeros_diferentes) {
        cambio += `Config Usan codigos camiseta cambia de  ${itemCom.usan_numeros_diferentes} a ${item.usan_numeros_diferentes}; `
      }
      if (item.show_vocalia != itemCom.show_vocalia) {
        cambio += `Config mostrar vocalias de  ${itemCom.show_vocalia} a ${item.show_vocalia}; `
      }
      if (item.show_edad != itemCom.show_edad) {
        cambio += `Config mostrar edad de ${itemCom.show_edad} a ${item.show_edad}; `
      }
      if (item.bloquear_informe_arbitro != itemCom.bloquear_informe_arbitro) {
        cambio += `Config bloquear informe Arbitral al guardar de  ${itemCom.bloquear_informe_arbitro} a ${item.bloquear_informe_arbitro}; `
      }
      let cambioSend = ''
      if (cambio != '') {
        cambioSend += `${item.disciplina} ${item.categoria} ${cambio}; `
      }
      // cambioSend = cambioSend.replace(/;/g, ';\n')
      // console.log(cambioSend)
      return cambioSend
    }
    async function updateConfig() {
      const path = 'ApiConfiguration/updateConfig'
      props.item.rol = USER().rol
      props.item.controla_por_sub = checkSub.value === true ? 's' : 'n'
      props.item.tiene_juvenil = checkJuvenil.value === true ? 's' : 'n'
      props.item.tiene_clasificado = checkClasificado.value === true ? 's' : 'n'
      props.item.restar_gol_np = checkRestarGoles.value === true ? 's' : 'n'
      props.item.borran_con_roja = checkBorranConRoja.value === true ? 's' : 'n'
      props.item.playofs = checkPlayOffs.value === true ? 's' : 'n'
      props.item.balon = checkBalon.value === true ? 's' : 'n'
      props.item.c_capitan = checkCapitan.value === true ? 's' : 'n'
      props.item.tribuna = checkTribuna.value === true ? 's' : 'n'
      props.item.camerino = checkCamerino.value === true ? 's' : 'n'
      props.item.faltas = checkFaltas.value === true ? 's' : 'n'
      props.item.calificacion = checkCalificacion.value === true ? 's' : 'n'
      props.item.calificacion_arbitro =
        checkCalificacion.value === true ? 's' : 'n'
      props.item.pasabolas = checkPasabolas.value === true ? 's' : 'n'
      props.item.show_acumulada = checkAcumulada.value === true ? '1' : '0'
      props.item.show_facial_web = checkFacialWeb.value === true ? '1' : '0'
      props.item.show_vocalia = checkVocaliasWeb.value === true ? '1' : '0'
      props.item.show_edad = checkEdadWeb.value === true ? '1' : '0'
      props.item.bloquear_informe_arbitro =
        checkBloquearInformeArbitroWeb.value === true ? '1' : '0'
      props.item.show_facial_vocalia =
        checkFacialVocalia.value === true ? '1' : '0'
      props.item.opc_cal_arbitro = radioSelect.value
      props.item.id_opc_cal_arbitro = radioSelect.value
      props.item.validar_por_anios =
        checkJuvenilFechas.value === true ? 's' : 'n'
      props.item.mostrar_movil = checkMostrarMovil.value === true ? 's' : 'n'
      props.item.usan_numeros_diferentes =
        checkUsanCodigos.value === true ? '1' : '0'

      const send = {
        item: props.item,
        idUser: USER().id_usuario,
        cambios: verifyChanges(props.item),
        idTorneo:
          store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
      }
      const response = await postApi(URL, path, send)
      if (response.flag === 'si') {
        emit('update', {
          item: props.item,
          pos: props.index,
          listAux: props.listAux,
        })
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'ACTUALIZADO con éxito',
              icon: 'AlertCircleIcon',
              variant: 'success',
              solid: true,
            },
          },
          {
            position: 'top-center',
          },
        )
      } else {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: response.mensaje,
              icon: 'AlertCircleIcon',
              variant: 'danger',
              solid: true,
            },
          },
          {
            position: 'top-center',
          },
        )
      }
      cardItem.value.showLoading = false
    }
    return {
      checkSub,
      checkJuvenil,
      checkJuvenilFechas,
      checkClasificado,
      calculateAgeLimitMax,
      limiteEdadMinima,
      limiteEdadMaxima,
      limiteEdadMinimaJuvenil,
      limiteEdadMaxJuvenil,
      verifyIsOpenInscription,
      isOpen,
      timeDiffInscription,
      updateConfig,
      cardItem,
      USER,
      ROLES,
      checkBorranConRoja,
      checkRestarGoles,
      checkPlayOffs,
      checkBalon,
      checkCapitan,
      checkTribuna,
      checkCamerino,
      checkFaltas,
      checkPasabolas,
      checkCalificacion,
      checkAcumulada,
      checkFacialWeb,
      checkVocaliasWeb,
      checkEdadWeb,
      checkBloquearInformeArbitroWeb,
      checkFacialVocalia,
      // showEtapas,
      getModalidad,
      listEtapas,
      colors,
      colorPase,
      radioSelect,
      eliminar,
      showNewValorFijo,
      showNewTipoAlterno,
      showResetTa,
      deleteValorFijo,
      deleteTipoAlterno,
      checkMostrarMovil,
      checkUsanCodigos,
      showNewConfigAcumulada,
      limiteEdadMinimaJuvenilDos,
    }
  },
}
</script>
<style lang="scss">
.radio-opciones {
  margin-bottom: 10px;
  margin-left: 13px;
}
.radio-opciones .custom-radio .custom-control-label {
  font-size: 10px;
  position: static;
  color: rgb(171, 169, 169);
}
.camp-activo {
  background: #00ff31;
  border-radius: 3px;
  padding: 6px;
  position: relative;
  font-size: 10px;
  text-transform: uppercase;
  font-weight: bolder;
}
.camp-anterior {
  background: #ffee00;
  border-radius: 3px;
  padding: 6px;
  position: relative;
  font-size: 10px;
  text-transform: uppercase;
  font-weight: bolder;
}
</style>
